var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useState } from 'react';
import { FactoryComponent } from '../../../factory';
import withDesign from '../../../hocs/withDesign';
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
import { Portal } from '../../atoms/Portal';
import { ContentContainer } from '../../templates/ContentContainer';
import { Button } from '../Button';
import { TranslatedText } from '../Button/ButtonContent';
export var PrimaryModalComponent = function (_a) {
    var schema = _a.schema, components = _a.components, as = _a.as, _b = _a.values, values = _b === void 0 ? {} : _b, header = _a.header, cancel = _a.cancel, confirm = _a.confirm, text = _a.text, children = _a.children, onConfirm = _a.onConfirm, onCancel = _a.onCancel, _c = _a.open, open = _c === void 0 ? false : _c;
    var portalStyle = useDesign(components.portal).schema.default;
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var actionsStyle = useDesign(components.actions).schema;
    var onConfirmHandler = function () {
        onConfirm && onConfirm();
        setIsOpen(false);
    };
    var onCancelHandler = function () {
        onCancel && onCancel();
        setIsOpen(false);
    };
    var onTriggerClick = function () {
        setIsOpen(true);
    };
    return (_jsxs(_Fragment, { children: [(isOpen || open) && (_jsx(Portal, __assign({ style: portalStyle }, { children: _jsxs(GenericComponent, __assign({ schema: schema, as: as }, { children: [components.header && (_jsx(TranslatedText, { element: "h2", design: components.header, i18n: header })), children && children, components.content && _jsx(ContentContainer, { values: values, design: components.content }), text && _jsx(TranslatedText, { values: values, design: components.text, i18n: text }), (components.cancel || components.confirm) && (_jsxs(GenericComponent, __assign({ schema: actionsStyle }, { children: [cancel && (_jsx(Button, { design: components.cancel, text: cancel, onClick: onCancelHandler })), confirm && (_jsx(FactoryComponent, { component: confirm.component, design: components.confirm, text: confirm.i18n, onClick: onConfirmHandler }))] })))] })) }))), _jsx(FactoryComponent, { "data-design": components.trigger, design: components.trigger, onClick: function () {
                    onTriggerClick();
                } })] }));
};
export var PrimaryModal = withDesign(PrimaryModalComponent);
PrimaryModal.displayName = 'PrimaryModal';
